// ALL FOOD GET
export const GET_ALL_FOOD_FETCH_START = "GET_ALL_FOOD_FETCH_START";
export const GET_ALL_FOOD_FETCH_SUCCESS = "GET_ALL_FOOD_FETCH_SUCCESS";
export const GET_ALL_FOOD_FETCH_FAILURE = "GET_ALL_FOOD_FETCH_FAILURE";

//POST INDIVISUAL FOOD
export const POST_FOOD_FETCH_START = "POST_FOOD_FETCH_START";
export const POST_FOOD_FETCH_SUCCESS = "POST_FOOD_FETCH_SUCCESS";
export const POST_FOOD_FETCH_FAILURE = "POST_FOOD_FETCH_FAILURE";


//GET INDIVIDUAL FOOD
export const GET_SINGLE_FOOD_START="GET_SINGLE_FOOD_START";
export const GET_SINGLE_FOOD_SUCCESS="GET_SINGLE_FOOD_SUCCESS";
export const GET_SINGLE_FOOD_FAILURE="GET_SINGLE_FOOD_FAILURE";

// FOOD REPORT 
export const GET_FOOD_REPORT_DATA="GET_FOOD_REPORT_DATA"
